import React, { useEffect, useState } from "react"
import { Helmet } from "react-helmet"

const EAHelmetSubcomp = ({ title, description }) => {
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    const loadActionTagScript = () => {
      if (document.querySelector('script[src="https://static.everyaction.com/ea-actiontag/at.js"]')) {
        setIsLoading(false);
        return;
      }
      const script = document.createElement("script")
      script.src = "https://static.everyaction.com/ea-actiontag/at.js"
      script.async = true
      script.crossOrigin = "anonymous"
      document.head.appendChild(script)
      script.onload = () => {
        setIsLoading(false)
      }
    }
    const delay = setTimeout(loadActionTagScript, 1700)
    return () => {
      clearTimeout(delay)
    }
  }, [])

  return (
    <>
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        {/* Preload for performance (optional) */}
        <link
          rel="preload"
          href="https://static.everyaction.com/ea-actiontag/at.min.css"
          as="style"
        />
         
  <link
    rel="stylesheet"
    href="https://nvlupin.blob.core.windows.net/images/van/TSM/TSM01/1/102529/images/csicon-2026-regform.css"
  />
      </Helmet>
      {isLoading && <div className="loader"></div>}
    </>
  )
}

export default EAHelmetSubcomp